(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["withChildComponents"] = factory();
	else
		root["withChildComponents"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports) {

	/**
	 * withChildComponents
	 *
	 * See the README.md for up-to-date docs.
	 */

	'use strict';

	var teardownEventCount = 0;

	/**
	 * attacher takes a function that generates event-name strings. The supplied function is
	 * called every time a child component is attached.
	 */
	function attacher(eventNameGenerator) {
	    if (typeof eventNameGenerator !== 'function') {
	        eventNameGenerator = withChildComponents.nextTeardownEvent;
	    }

	    return function attach(Component, destination) {
	        var attrs = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

	        if (!attrs.teardownOn) {
	            attrs.teardownOn = eventNameGenerator.call(this);
	        }
	        var mixins = Component.prototype.mixedIn || [];
	        var isMixedIn = mixins.indexOf(withBoundLifecycle) > -1;
	        var ComponentWithMixin = isMixedIn ? Component : Component.mixin(withBoundLifecycle);
	        ComponentWithMixin.attachTo(destination, attrs);

	        return {
	            teardownEvent: attrs.teardownOn
	        };
	    };
	}

	function withBoundLifecycle() {
	    // Use deprecated defaultAttrs() only if necessary
	    var defineDefaultAttributes = this.attrDef ? this.attributes : this.defaultAttrs;
	    defineDefaultAttributes.call(this, {
	        teardownOn: ''
	    });

	    /**
	     * If we were given a teardownOn event then listen out for it to teardown.
	     */
	    this.after('initialize', function () {
	        if (this.attr.teardownOn) {
	            if (this.attr.teardownOn === this.childTeardownEvent) {
	                throw new Error('Component initialized to listen for its own teardown event.');
	            }
	            this.on(document, this.attr.teardownOn, function () {
	                this.teardown();
	            });
	        }
	    });
	}

	function withChildComponents() {
	    /**
	     * Give every component that uses this mixin a new, unique childTeardownEvent
	     */
	    this.before('initialize', function () {
	        this.childTeardownEvent = this.childTeardownEvent || withChildComponents.nextTeardownEvent();
	    });

	    /**
	     * Before this component's teardown, tell all the children to teardown
	     */
	    this.before('teardown', function () {
	        this.trigger(this.childTeardownEvent);
	    });

	    /**
	     * Utility method for attaching a component with teardownOn.
	     *
	     * Takes Component (with attachTo method) plus destination and attrs arguments, which should
	     * be the same as in a normal attachTo call.
	     */
	    this.attachChild = attacher(function () {
	        return this.childTeardownEvent;
	    });
	}

	withChildComponents.nextTeardownEvent = function () {
	    teardownEventCount += 1;
	    return '_teardownEvent' + teardownEventCount;
	};

	withChildComponents.withBoundLifecycle = withBoundLifecycle;

	/**
	 * `attach` helps non-Flight code attach components and tear them down.
	 *
	 * Example usage:
	 *
	 *      const { teardownEvent } = attach(Component, $someNode, { ... });
	 *
	 *      ... sometime later ...
	 *
	 *      $(document).trigger(teardownEvent);
	 */
	withChildComponents.attach = attacher(function () {
	    // This is called in this function, rather than passed directly, so that the
	    // generator can be tested
	    return withChildComponents.nextTeardownEvent();
	});

	module.exports = withChildComponents;

/***/ }
/******/ ])
});
;


//////////////////
// WEBPACK FOOTER
// ./~/flight-with-child-components/dist/flight-with-child-components.js
// module id = 232
// module chunks = 85